/* eslint-disable */
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "../../services/Axios/axios";
import RenderITOfficerPage from "../RenderITOfficerPage";
import UploadCard from "../components/UploadCard";

/**
 * UPNMG staff MART deductions. Same sheet format as UploadMart — the backend
 * tags these rows member_type='STAFF' so they stay out of the member figures.
 */
function UploadStaffMart() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const handleUpload = async (file) => {
    setIsLoading(true);
    setResponse(null);
    try {
      const formData = new FormData();
      formData.append("file", file);
      await axiosInstance.post("/loans/staff/upload-mart-deduction", formData);
      setResponse({ state: "SUCCESS", message: "Staff mart deductions uploaded successfully. Processing in background." });
      toast.success("Staff mart deductions uploaded successfully");
    } catch (e) {
      const msg = e?.response?.data?.message ?? "Upload failed. Try again.";
      setResponse({ state: "ERROR", message: msg });
      toast.error(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <RenderITOfficerPage title="Upload Staff Mart">
      <UploadCard
        title="Upload Staff Mart Deductions"
        description="Upload an Excel or CSV file of mart deductions for UPNMG staff. Same columns as the member sheet — these records are kept separate from member deductions."
        onUpload={handleUpload}
        isLoading={isLoading}
        response={response}
        accentColor="emerald"
      />
      <ToastContainer autoClose={3000} />
    </RenderITOfficerPage>
  );
}

export default UploadStaffMart;
